export default function withLenis<P extends object>(
  Component: React.ComponentType<P>
) {
  return function LenisComponent(props: P) {
    return <Component {...props} />
  }
}
